import React, { createContext, useContext, ReactNode } from 'react';
import { Tab } from '../types/chat';
import { useChatTabs } from '../hooks/Chat/useChatTabs';
import { getMessagesForTopic } from '../utils/MessageHistory.js';
const STORAGE_KEY = 'chat_tabs';
interface ChatTabsContextType {
  tabs: Tab[];
  setTabs: React.Dispatch<React.SetStateAction<Tab[]>>;
  activeTab: string;
  setActiveTab: React.Dispatch<React.SetStateAction<string>>;
  deleteDialogOpen: boolean;
  handleConfirmDelete: () => void;
  handleCancelDelete: () => void;
  handleCloseTab: (tabId: string) => void;
  truncateTopic: (text: string, maxLength?: number | { xs: number; md: number }) => string;
}
const ChatTabsContext = createContext<ChatTabsContextType | undefined>(undefined);
export const ChatTabsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const {
    tabs,
    setTabs,
    activeTab,
    setActiveTab,
    deleteDialogOpen,
    handleConfirmDelete,
    handleCancelDelete,
    handleCloseTab,
    truncateTopic,
  } = useChatTabs({
    topic: null,
    getMessagesForTopic,
    storageKey: STORAGE_KEY,
  });
  return (
    <ChatTabsContext.Provider
      value={{
        tabs,
        setTabs,
        activeTab,
        setActiveTab,
        deleteDialogOpen,
        handleConfirmDelete,
        handleCancelDelete,
        handleCloseTab,
        truncateTopic,
      }}
    >
      {children}
    </ChatTabsContext.Provider>
  );
};
export const useChatTabsContext = () => {
  const context = useContext(ChatTabsContext);
  if (context === undefined) {
    throw new Error('useChatTabsContext must be used within a ChatTabsProvider');
  }
  return context;
};
